import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'sted';
            break;
        case 'sted':
            nextPage = 'beskriv-skaden';
            break;
        case 'beskriv-skaden':
            nextPage = 'om-baaden';
            break;
        case 'om-baaden':
            if (
                getValueOrDefault(formConfig, formValues, 'hvaderdersketmedbden').value ===
                'Kæntret, sunket, strandet eller grundstødt'
            ) {
                nextPage = 'foerer';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvaderdersketmedbden').value === 'Skadet i en kollision'
            ) {
                nextPage = 'foerer';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvaderdersketmedbden').value ===
                'Skadet under ophaling/søsætning eller væltet på land'
            ) {
                nextPage = 'ophaling';
            } else {
                nextPage = 'skyld';
            }
            break;
        case 'foerer':
            if (
                getValueOrDefault(formConfig, formValues, 'hvaderdersketmedbden').value ===
                'Kæntret, sunket, strandet eller grundstødt'
            ) {
                if (getValueOrDefault(formConfig, formValues, 'hvemvarfrerafdinbaadKaentret').value === 'Andre') {
                    nextPage = 'om-foerern';
                } else {
                    nextPage = 'om-bjaergning';
                }
            } else {
                if (getValueOrDefault(formConfig, formValues, 'hvemvarfrerafdinbaadKaentret').value === 'Andre') {
                    nextPage = 'om-foerern2';
                } else {
                    nextPage = 'modparter';
                }
            }
            break;
        case 'om-foerern2':
            nextPage = 'lokation';
            break;
        case 'modparter':
            nextPage = 'lokation';
            break;
        case 'om-foerern':
            nextPage = 'lokation';
            break;

        case 'om-bjaergning':
            nextPage = 'lokation';
            break;
        case 'ophaling':
            nextPage = 'lokation';
            break;
        case 'skyld':
            nextPage = 'lokation';
            break;
        case 'lokation':
            if (getValueOrDefault(formConfig, formValues, 'hvorerbdennu').value === 'Et andet sted') {
                nextPage = 'adresse';
            } else {
                nextPage = 'erstatning';
            }
            break;
        case 'adresse':
            nextPage = 'erstatning';
            break;
        case 'erstatning':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
